import { gql, useQuery } from "@apollo/client";
export const UpdateMachineItems = gql`
	mutation UpdateMachineItems($id: String!, $items: [String]) {
		updateMachineItems(input: { id: $id, items: $items }) {
			_id
		}
	}
`;
